import { Row, Col } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { isValidElement } from "react";
import {
  Body,
  CustomizationDialogContainer,
  Modal,
  Title,
  Button,
  BodyCenter,
} from "./CustomizationDialog.styled";

const styles = {
  buttonGroup: { marginTop: "16px" },
  button: { margin: "4px 0px" },
};

export type CustomizationInfoDialogProps = {
  title: string;
  body: string | JSX.Element;
  onConfirm?: () => void;
  onReject?: () => void;
  isVisible?: boolean;
  isLoading?: boolean;
  confirmText?: string | JSX.Element;
  rejectText?: string;
  image?: JSX.Element;
  width?: number;
  centered?: boolean;
};

const CustomizationInfoDialog = ({
  title,
  body,
  isVisible = true,
  onConfirm,
  isLoading,
  confirmText = "Confirm",
  image,
  width,
  centered,
  ...props
}: CustomizationInfoDialogProps) => {
  const { sm } = useBreakpoint();
  const modalWidth = width || (sm ? "502px" : "auto");
  const bodyComponent = isValidElement(body) ? (
    <Body>{body}</Body>
  ) : (
    <BodyCenter>{body}</BodyCenter>
  );
  return (
    <Modal
      centered={centered}
      width={modalWidth}
      visible={isVisible}
      footer={null}
      closable={false}
      data-testid="info-dialog-modal"
      data-gtm-input-code="info-dialog-modal"
      {...props}
    >
      {image && <>{image}</>}
      <CustomizationDialogContainer>
        <Title>{title}</Title>
        {bodyComponent}
        <Row justify="center" style={styles.buttonGroup}>
          <Col span={24}>
            <Button
              data-testid="info-dialog-confirm-button"
              data-gtm-input-code="info-dialog-confirm-button"
              onClick={onConfirm}
              loading={isLoading}
              style={styles.button}
            >
              {confirmText}
            </Button>
          </Col>
        </Row>
      </CustomizationDialogContainer>
    </Modal>
  );
};
export default CustomizationInfoDialog;
